import React, { memo } from 'react';
import classNames from 'classnames';
import DropDown, { DropDownElement } from 'src/components/helpers/DropDown/index';
import URLMaker from 'src/routing/UrlMaker';
import { getIn } from 'src/utils/ChangeSpy';

import style from './style.module.css';

const CompanyProfileComponent = ({ className, id, subsidiaries, disabled, statuses }) => {
  const getLink = company =>
    URLMaker.create('/company/:companyId/buyer').mapParams({
      companyId: company.get('id'),
    });

  const getTitle = status =>
    statuses.size
      ? statuses.find(statusItem => getIn(statusItem, ['value']) === status, null, statuses.get(0)).get('name')
      : '';

  const getLine = i => {
    const company = subsidiaries.get(i);
    const currentStatus = company.get('buyerCurrentStatus', '?');
    const highStatus = company.get('buyerHighStatus', '?');

    return (
      <DropDownElement
        key={i}
        className={classNames(style.option, 'display-block')}
        href={getLink(company)}
        target="_blank"
      >
        <span className={style.line}>
          <span>{company.get('legalName', '')}</span>
          <span>
            <span title={getTitle(currentStatus)}>{currentStatus}</span>/
            <span title={getTitle(highStatus)}>{highStatus}</span>
          </span>
        </span>
      </DropDownElement>
    );
  };

  const getButtonContent = () => {
    const company = subsidiaries.get(0);
    const currentStatus = company.get('buyerCurrentStatus', '?');
    const highStatus = company.get('buyerHighStatus', '?');

    return (
      <span>
        Portfolio <span title={getTitle(currentStatus)}>{currentStatus}</span>/
        <span title={getTitle(highStatus)}>{highStatus}</span>
      </span>
    );
  };

  return subsidiaries.get(0) ? (
    <div className={className}>
      <DropDown
        buttonContent={getButtonContent()}
        className="btn btn-xs btn-default"
        disabled={disabled}
        id={id}
        wrapperClassName={style.dropdown}
        isValuePicker
      >
        {subsidiaries.map((v, i) => getLine(i))}
      </DropDown>
    </div>
  ) : null;
};

/** Company profile component. */
export const CompanyProfile = memo(CompanyProfileComponent);
